
import React, { Fragment } from 'react';
import { Col, Container, Row, Toast, ToastBody, ToastHeader } from 'react-bootstrap';
import { ArcaClientImageServer } from '../../../code/ArcaClientImageServer';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaUtil } from '../../../code/ArcaUtil';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { TickCross } from '../ReactIcons/TickCross';
import { StatusBar } from '../StatusBar';
import { PhotoUploadPanel } from './PhotoUploadPanel';

export class PhotoMultiUpload extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            imageKey: ArcaUtil.RandomString(5),
            isLoading: false,
            isError: false,
            statusMessage: null
        };
    }

    componentDidMount() {
        let { folder } = this.props;

        ArcaClientImageServer.GetImages(
            folder,
            (images => { this.setState({ images }) }),
            (() => this.setState({ isError: true, statusMessage: "No images found" })),
            (msg => this.setState({ isError: true, statusMessage: msg }))
        )
    }

    toggleToDelete(image) {
        image.ToDelete = !image.ToDelete;
        this.setState({ images: this.state.images });
    }

    deleteMarkedImages() {
        this.state.images
            .filter(i => i.ToDelete)
            .map((i, k) =>
                ArcaClientImageServer.DeleteImage(
                    i,
                    (() => alert('success')),
                    ((msg) => alert('failure:' + msg))
                )
            )
    }

    render() {
        let { images } = this.state;
        let { folder, isError, statusMessage } = this.props;

        return (
            <Fragment>
                <div className="rounded px-3 px-sm-4 py-3 py-sm-5">
                    <h1>Image Uploader</h1>
                    <p>Select or drag images of interest onto this page</p>
                    <StatusBar isError={isError} message={statusMessage} />
                    <PhotoUploadPanel
                        folder={folder}
                        uploadStarted={() => this.setState({ isLoading: true })}
                        imageUpdated={(() => this.setState({ imageKey: ArcaUtil.RandomString(5), isLoading: false }))} />
                </div>
                <div className="rounded px-3 px-sm-4 py-3 py-sm-5">
                    <h1>Existing images</h1>
                    <div className='centerText'>
                        {images?.some(x => x.ToDelete === true)
                            ? <ArcaLink
                                text='Remove marked images'
                                width='225px'
                                onClick={() => this.deleteMarkedImages()}
                            />
                            : null}
                    </div>

                    <Container>
                        <Row>
                            {images
                                ? images.map((image, key) =>
                                    <Col key={key}>
                                        <div className="p-3 my-2 rounded">
                                            <Toast onClick={() => this.toggleToDelete(image)}>
                                                <ToastHeader>
                                                    <TickCross ticked={!image.ToDelete} height='25px' />
                                                    {' '}{image.Name}
                                                </ToastHeader>
                                                <ToastBody>
                                                    <img
                                                        className = 'photoImage'
                                                        src={`${ArcaHttpSystem.PhotoFolder}${image.Folder}/${image.Name.replace('.jpg', 'TN.jpg')}`}
                                                        alt={image.Name}
                                                    />
                                                </ToastBody>
                                            </Toast>
                                        </div>
                                    </Col>)
                                : null}

                        </Row>
                    </Container>

                </div>
            </Fragment>
        );
    }
}